<template>
  <Wrapper :client="client">
    <div class="flex flex-col bg-gray-100">
      <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div
          class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <div class="overflow-hidden">
            <h1 class="m-3 text-lg font-medium text-font-dark">
              Client Contacts
            </h1>
          </div>
          <div
            v-if="contacts.length === 0"
            class="flex flex-1 items-center justify-between truncate rounded-md">
            <div
              class="mb-8 flex-1 truncate p-2 text-center text-sm">
              <a
                href="#"
                class="font-medium text-gray-500 hover:text-gray-600"
                @click="showCreateFrom = !showCreateFrom">No contacts on this client yet</a>
            </div>
          </div>
          <ul
            class="z-10 m-3 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            <client-contact-card
              v-for="contact in contacts"
              :client="client"
              :contact="contact" />
          </ul>
          <div class="m-3">
            <button
              type="button"
              class="mt-5 inline-flex cursor-pointer justify-center rounded-md border border-primary bg-white px-4
                py-3 text-sm font-medium text-font-darkest shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
              @click="showCreateFrom = !showCreateFrom">
              <!-- Heroicon name: user-add -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="mr-2 size-5 text-gray-400"
                viewBox="0 0 20 20"
                fill="currentColor">
                <path
                  d="M8 9a3 3 0 100-6 3 3 0 000 6zM8 11a6 6 0 016 6H2a6 6 0 016-6zM16 7a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V7z" />
              </svg>
              Add New Client Contact
            </button>
          </div>
        </div>
      </div>
    </div>
  </Wrapper>

  <CreateClientContact
    :show="showCreateFrom"
    :client="client"
    @close="showCreateFrom = false" />
</template>

<script>
import Wrapper from './Wrapper.vue';
import CreateClientContact from '../../ComponentsDeprecated/Modal/CreateClientContact.vue';
import ClientContactCard from './ClientContactCard.vue';

export default {
  name: 'ContactsTab',
  components: {
    Wrapper,
    CreateClientContact,
    ClientContactCard,
  },

  props: {
    client: Object,
    contacts: Array,
  },

  data() {
    return {
      showCreateFrom: false,
    };
  },

  watch: {},
  created() {},
  methods: {},
};
</script>

<style scoped></style>
